import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientEmergencyContacts = (state, patientId) =>
  allModelsSelector(state, 'PatientEmergencyContact', (c) => c.patientId === patientId);
